import React, { useState } from 'react';
import Link from 'next/link';
import {
  Collapse,
  List,
  ListItemIcon,
  ListItemText,
  Link as ButtonLink,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ChevronUp, ChevronDown } from 'lucide-react';

import { UserLoginButton } from '../../../user-login-button';
import { APP_SUB_MENU } from '../../../user-popover/constants';
import { StyledLinkItem } from '@mais-retorno-front/components/navbar/styles';

import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';
import { useAuth } from '@core/features-core/auth/client';

export const LoginButtonOrUser = () => {
  const theme = useTheme();
  const { userIsLogged, logout } = useAuth();

  const [openMenu, setOpenMenu] = useState(false);

  if (!userIsLogged) {
    return (
      <StyledLinkItem style={{ marginTop: 30 }}>
        <UserLoginButton showMobile />
      </StyledLinkItem>
    );
  }

  return (
    <>
      <StyledLinkItem
        style={{ marginTop: 30 }}
        onClick={() => setOpenMenu((state) => !state)}
      >
        <ListItemText>
          <UserLoginButton showMobile />
        </ListItemText>
        {openMenu ? (
          <ChevronUp size={20} color={theme.palette.secondary.main} />
        ) : (
          <ChevronDown size={20} />
        )}
      </StyledLinkItem>
      <Collapse in={openMenu} timeout="auto" unmountOnExit>
        <List component="div">
          {APP_SUB_MENU.filter((item) => {
            if (!item.allowedRoles) return true;

            return false;
          }).map(({ label, link, icon }) => (
            <Link
              key={link}
              href={link}
              passHref
              legacyBehavior
              prefetch={false}
            >
              <StyledLinkItem component={ButtonLink} color="inherit">
                <ListItemIcon></ListItemIcon>
                <ListItemText primary={label} />
              </StyledLinkItem>
            </Link>
          ))}
          <Link
            key="user-profile"
            href={DEFAULT_ROUTES.userProfile}
            passHref
            prefetch={false}
          >
            <StyledLinkItem component={ButtonLink} color="inherit">
              <ListItemIcon></ListItemIcon>
              <ListItemText primary="Meu perfil" />
            </StyledLinkItem>
          </Link>
          <StyledLinkItem color="inherit" onClick={() => logout()}>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary="Sair" />
          </StyledLinkItem>
        </List>
      </Collapse>
    </>
  );
};
